import { useEffect, useState } from "react";

const MOBILE_BP = 768;
const MODES = ["table", "grid", "list"];

/**
 * Data view mode: "table" | "grid" | "list". Persists the user's choice per page
 * (localStorage). On mobile (<= 768px) the table is not available: a stored
 * "table" preference resolves to "grid", and the toggle only offers grid/list.
 */
export default function useViewMode(storageKey = "viewMode") {
    const isMobileNow = () => typeof window !== "undefined" && window.innerWidth <= MOBILE_BP;
    const [isMobile, setIsMobile] = useState(isMobileNow);
    const [pref, setPref] = useState(() => {
        if (typeof localStorage === "undefined") return "table";
        const stored = localStorage.getItem(storageKey);
        if (MODES.includes(stored)) return stored;
        if (stored === "cards") return "grid"; // backward compatibility
        return "table";
    });

    useEffect(() => {
        const onResize = () => setIsMobile(isMobileNow());
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const setView = (v) => {
        if (!MODES.includes(v)) return;
        setPref(v);
        if (typeof localStorage !== "undefined") localStorage.setItem(storageKey, v);
    };

    // mobile can't show the table
    const view = isMobile && pref === "table" ? "grid" : pref;
    return { view, setView, isMobile };
}
